<template>
  <div>{{ t }}</div>
</template>
<script>
export default {
  props: ["time"],
  data() {
    return { t: "" };
  },
  methods: {},
  mounted() {
    this.t = this.utils.xdsj(this.time);
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/time.vue